import { Component, Input, OnInit } from '@angular/core';

/**
 * Reusable Component to show simple repeating row skeleton with header 
 *
 * @class SimpleRowRepeatingSkeletonComponent
 * @implements {OnInit}
 */
@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'simple-row-repeating-skeleton',
	templateUrl: './simple-row-repeating-skeleton.component.html',
	styleUrls: ['./simple-row-repeating-skeleton.component.scss']
})
export class SimpleRowRepeatingSkeletonComponent implements OnInit {
	@Input() public rowCount: number = 3;
	public GHOST_ROWS;

	public ngOnInit(): void {
		this.GHOST_ROWS = Array(this.rowCount).fill(0);
	}
}
